import{__require as r}from"./fails.js";var t,e;function o(){if(e)return t;e=1;var o=r();return t=!o((function(){function r(){}return r.prototype.constructor=null,Object.getPrototypeOf(new r)!==r.prototype}))}export{o as __require};
//# sourceMappingURL=correct-prototype-getter.js.map
